import { useTranslation } from "react-i18next";
import { NavLink, useLocation } from "react-router-dom";
import React from "react";
import clsx from "clsx";

import { LanguageSelector } from "./LanguageSelector.jsx";
import { ProfileMenu } from "./ProfileMenu.jsx";
import { useApp } from "../hooks/useApp.js";
import Container from "./Container.jsx";
import SvgIcon from "./SvgIcon.jsx";

const PageNavigation = ({ links, useColours }) => {
  const { t } = useTranslation();
  const { isMenuOpen, toggleMenu } = useApp();
  const location = useLocation();
  const isHomePath = location.pathname === "/";
  return (
    <header>
      <nav>
        <Container className="z-0 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div>
            <div
              className={clsx("mb-2 flex items-center justify-between", isHomePath ? "h-16 lg:h-20" : "h-12 lg:h-16")}
            >
              {/* Desktop Menus */}
              <div className="hidden lg:flex lg:flex-1 lg:items-center">
                <NavLink to="/">
                  <span className="sr-only">{t("proof.title")}</span>
                  <img
                    className={clsx("w-auto", isHomePath ? "h-14" : "h-8")}
                    src="/images/proof-logo.png"
                    alt={t("proof.title")}
                  />
                </NavLink>
              </div>

              {/* Mobile Menus */}
              <div className="relative flex flex-1 items-center lg:hidden">
                <button
                  onClick={toggleMenu}
                  type="button"
                  className="hover:bg-opacity-50 -ml-2 rounded-full p-2 hover:bg-gray-600"
                >
                  <span className="sr-only">Open menu</span>
                  <SvgIcon type="mobile" />
                </button>
              </div>

              <div className="hidden h-8 lg:flex">
                <div className="inset-x-0 bottom-0 px-4">
                  <div className="flex h-full justify-center space-x-6">
                    {Array.isArray(links) && links.length > 0
                      ? links.map((link, index) => (
                          <NavLink
                            key={index}
                            to={link.path}
                            className={({ isActive }) =>
                              clsx(
                                "navigation-link",
                                isActive && "navigation-active",
                                isActive && !useColours && "border-black dark:border-white",
                                useColours && isActive && link.colour,
                              )
                            }
                          >
                            {link.title}
                          </NavLink>
                        ))
                      : undefined}
                  </div>
                </div>
              </div>

              <a href="/" className="lg:hidden">
                <span className="sr-only">{t("proof.title")}</span>
                <img
                  className={clsx("w-auto", isHomePath ? "h-8 lg:h-14" : "h-8")}
                  src="/images/proof-logo.png"
                  alt={t("proof.title")}
                />
              </a>

              <div className="z-20 flex h-8 flex-1 items-center justify-end gap-3">
                <LanguageSelector />
                <ProfileMenu />
              </div>
            </div>

            <div
              className={clsx(
                "flex justify-around space-x-0 transition-all delay-150 duration-300 sm:justify-center sm:space-x-6 lg:hidden lg:space-x-6",
                isMenuOpen ? "overflow mb-2 h-8" : "h-0 overflow-hidden opacity-0",
              )}
            >
              {Array.isArray(links) && links.length > 0
                ? links.map((link, index) => (
                    <NavLink
                      key={index}
                      to={link.path}
                      className={({ isActive }) =>
                        clsx("navigation-link mobile z-0", useColours && link.colour, isActive && "navigation-active")
                      }
                    >
                      {link.title}
                    </NavLink>
                  ))
                : undefined}
            </div>
          </div>
        </Container>
      </nav>
    </header>
  );
};
export default PageNavigation;
